<template>
  <VLayout row wrap pa-4>
    <VFlex xs12>
      <VCard>
        <VCardTitle>
          <VLayout row wrap>
            <VFlex xs2>
              <h2>Potrjeni računi po uporabnikih</h2>
            </VFlex>
            <VFlex xs7 d-flex>
              <VFlex xs2>
                <VBtn class="ma-3" depressed small color="primary" @click="setPreviousMonth">
                  Pretekli mesec
                </VBtn>
              </VFlex>
              <VFlex xs2 class="ml-2">
                <VMenu
                  ref="fromDate"
                  v-model="fromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <VTextField
                    slot="activator"
                    :value="computedFromDate"
                    label="Obdobje od"
                    prepend-icon="event"
                    clearable
                    readonly
                  />
                  <VDatePicker
                    v-model="fromDate"
                    no-title
                    :max="toDate"
                    @change="fromMenu = false"
                  />
                </VMenu>
              </VFlex>
              <VFlex xs2 class="ml-4">
                <VMenu
                  ref="toDate"
                  v-model="toMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <VTextField
                    slot="activator"
                    :value="computedToDate"
                    label="Obdobje do"
                    prepend-icon="event"
                    clearable
                    readonly
                  />
                  <VDatePicker v-model="toDate" :min="fromDate" no-title @change="toMenu = false" />
                </VMenu>
              </VFlex>
              <VFlex xs3 class="px-2">
                <VSelect
                  v-model="documentType"
                  label="Vrsta dokumenta"
                  :items="documentTypeItems"
                />
              </VFlex>
              <VFlex xs3 class="pl-1">
                <VSelect
                  v-model="documentSource"
                  label="Vir dokumenta"
                  :items="documentSourceItems"
                />
              </VFlex>
              <VFlex class="ml-2">
                <VBtn
                  class="ma-3"
                  depressed
                  small
                  color="primary"
                  @click="getInvoicesProcessedByUser"
                >
                  Potrdi
                </VBtn>
              </VFlex>
            </VFlex>
            <VFlex xs3>
              <VTextField
                v-model="searchModel"
                append-icon="search"
                label="Iskanje"
                single-line
                hide-details
              />
            </VFlex>
          </VLayout>
        </VCardTitle>
        <VContainer fill-height fluid>
          <VLayout fill-height>
            <VFlex xs12>
              <VDataTable
                :headers="headers"
                :items="processedByUser"
                :search="searchModel"
                hide-actions
                style="max-height: 75vh; overflow: auto"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center">
                    {{ props.item.confirmed_by }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.count }}
                  </td>
                </template>
                <template slot="no-data"> Sorry, nothing to display here :( </template>
              </VDataTable>
            </VFlex>
          </VLayout>
        </VContainer>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ProcessedByUser',
  filters: {
    formatDateFilter(date) {
      return new Date(date).toLocaleString('de-DE').replace(',', '');
    },
  },
  data() {
    return {
      limit: 50,
      confirmedInvoices: false,
      errorInvoices: false,
      searchModel: '',
      fromMenu: false,
      fromDate: null,
      toMenu: false,
      toDate: null,
      toDateFormatted: null,
      fromDateFormatted: null,
      documentType: { text: 'Vsi', value: 'ALL' },
      documentSource: { text: 'Vsi', value: 'ALL' },
      headers: [
        { text: 'Uporabniško ime', value: 'confirmed_by', align: 'center' },
        { text: 'Število potrjenih računov', value: 'count', align: 'center' },
      ],
      documentTypeItems: [
        { text: 'Vsi', value: 'ALL' },
        { text: 'Prejeti račun', value: 'INV' },
        { text: 'Ostalo', value: 'OST' },
        { text: 'Izdani račun', value: 'IRN' },
      ],
      documentSourceItems: [
        { text: 'Vsi', value: 'ALL' },
        { text: 'Mail', value: 'MAIL' },
        { text: 'Unija Scan', value: 'UNSC' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      processedByUser: 'processedByUser',
    }),
    computedToDate() {
      return this.toDate ? this.$moment(this.toDate).format('DD.MM.YYYY') : '';
    },
    computedFromDate() {
      return this.fromDate ? this.$moment(this.fromDate).format('DD.MM.YYYY') : '';
    },
  },
  mounted() {
    this.toDate = this.$moment().format('YYYY-MM-DD');
    this.fromDate = this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD');
    this.getInvoicesProcessedByUser();
  },
  methods: {
    ...mapActions(['getProcessedByUserAction']),
    getInvoicesProcessedByUser() {
      const params = {
        confirmed_at_after: this.fromDate,
        confirmed_at_before: this.toDate,
        document_type:
          this.documentType.value === 'ALL' || this.documentType === 'ALL'
            ? ''
            : this.documentType.value || this.documentType,
        document_source: this.documentSource.value || this.documentSource,
      };
      this.getProcessedByUserAction(params);
    },
    setPreviousMonth() {
      const previousMonth = this.$moment().subtract(1, 'month');
      this.fromDate = previousMonth.startOf('month').format('YYYY-MM-DD');
      this.toDate = previousMonth.endOf('month').format('YYYY-MM-DD');
    },
  },
};
</script>

<style scoped></style>
